import { Button as AntdButton } from 'antd';
import React from 'react';
import './Button.scss';
export const Button = (props) => {
    return React.createElement(AntdButton, Object.assign({}, props, { type: props.type || 'primary' }));
};
